const { object, string, number, array, addMethod } = require('yup');

addMethod(string, 'noInvalidChars', function () {
  return this.test('noInvalidChars', 'Contains invalid character', function (value) {
    const badChars = /[|%"<>@\\]/g;
    const badJS = /javascript:/i;
    if (badChars.test(value) || badJS.test(value)) {
      return this.createError({
        message: 'Contains invalid character',
      });
    }

    return true;
  });
});

const schema = (messages = {}) => object().shape({
  firstName: string()
    .noInvalidChars()
    .required(messages?.firstName?.required ?? 'First Name cannot be blank'),
  lastName: string()
    .noInvalidChars()
    .required(messages?.lastName?.required ?? 'Last Name cannot be blank'),
  email: string()
    .email(messages?.email?.email ?? 'Invalid email address')
    .required(messages?.email?.required ?? 'Email address cannot be blank'),
  jobRole: array()
    .of(string().required(messages?.jobRole.required ?? 'Job Role cannot be blank'))
    .min(1, messages?.jobRole?.required ?? 'Job Role cannot be blank'),
  partnerId: number()
    .transform((val, orig) => (orig === '' ? undefined : val))
    .required(messages?.partnerId.required ?? 'Partner ID cannot be blank'),
  companyName: string()
    .noInvalidChars()
    .required(messages?.company?.required ?? 'Company cannot be blank'),
});

module.exports = schema;
